module.exports = __webpack_public_path__ + "static/media/RaisingChildren_web_2.9056ac63.jpg";